import { useMutation } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { StoreSettingsContext } from 'store/StoreSettingsContext'
import { useTranslation } from 'libs/i18n'

export const useChangePrimaryColorMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const storeCtx = useContext(StoreSettingsContext)

	const { mutate: changePrimaryColorMutation } = useMutation({
		mutationFn: (data: any) => {
			// TODO: change to apiRoutes
			return axiosPrivate.put('/settings/widget/', data)
		},
		onSuccess: (res) => {
			storeCtx?.setPrimaryColor(res.data.primary_color)
			useToast({
				type: 'success',
				message: t('Accent color updated')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t(`Couldn't update accent color`)
			})()
		}
	})

	return {
		changePrimaryColorMutation
	}
}
